import { FilterTypesEnum } from '../enums/filters-types.enum';
import { FilterTypeTextModel } from './filter-type-text.model';

export class FilterTypeSingleTextModel extends FilterTypeTextModel {
    readonly key: FilterTypesEnum = FilterTypesEnum.singleText;

    constructor(
        id: string,
        label: string,
        value?: string[],
        placeholder?: string,
        showMagnifyingGlass: boolean = true,
        showAddCustomButton: boolean = false,
        prefix?: string,
        section?: string,
        useExactQuickSearchString?: boolean
    ) {
        super(id, label, value, placeholder, showMagnifyingGlass, showAddCustomButton, prefix, section, useExactQuickSearchString);
    }

    /**
     * Sets the active value for a filter
     * @param value
     */
    setValue(value: string[]): void {
        if (this.value?.length && value?.length > 1) {
            this.value = value?.[1] ? [value?.[1]] : [];
        } else {
            this.value = value?.[0] ? [value?.[0]] : [];
        }

        this.chips = this.value.map((val) => {
            return {label: val};
        });
        this.cancelChanges();
    }

    /**
     * Sets the current value for a filter
     * @param value
     */
    setCurrentValue(value: string[]): void {
        this.currentValue = value;
        this.currentChips = this.currentValue.map((val) => {
            return {label: val};
        });
    }
}
